class upsells extends HTMLElement {
  constructor() {
    super();  
    this.addEventListener('input', this.formInputEvents);
    this.responsiveTooltip();
  }

  responsiveTooltip(event) {
    const tooltips = document.querySelectorAll('.shipping-popup-container');

    if (tooltips.length === 0) return;
    
    tooltips.forEach(tooltip => {
      const trigger = tooltip.querySelector('.shipping-popup-ctr');
      
      // Ouvrir le tooltip au tap
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Fermer tous les autres tooltips
        tooltips.forEach(t => t.classList.remove('tooltip-open'));
        
        // Ouvrir le tooltip actuel
        tooltip.classList.add('tooltip-open');
      });
    });
    
    // Fermer le tooltip en tapant ailleurs
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.shipping-popup-container')) {
        tooltips.forEach(tooltip => tooltip.classList.remove('tooltip-open'));
      }
    });
    
    // Fermer le tooltip avec la touche Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        tooltips.forEach(tooltip => tooltip.classList.remove('tooltip-open'));
      }
    });
  }

  formInputEvents(event) {
    if (event.target.hasAttribute('data-upsell-checkbox')) {
      const target = event.target;
      const id = target.dataset.id;
      console.log(target, 'FormEvent');
      if (target.checked) {
        console.log('add items');
        this.updateCart(id);
      } else {
        this.removeItem(id);
        console.log('remove items');
      }
    }
  }

  updateCart(id, qty = 1) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        quantity: qty,
      }),
    })
      .then((response) => {
        if (response.status == 200) {
          console.log('added to cart success');
        }
        return response.json();
      })
      .then((values) => {
        const errorMessage = values.description;
        if (errorMessage) {
          console.log(errorMessage, ' ERROR');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.updateCartPage();
      });
  }
  removeItem(id) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Item removed:', data);
      })
      .catch((error) => {
        console.error('Remove from cart failed:', error);
      })
      .finally(() => {
        this.updateCartPage();
      });
  }

  updateCartPage() {
    console.log('Lets get the cart page info');
    const url = `${window.Shopify.routes.root}?sections=cart`;
    console.log('fetch url', url);

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const htmlString = data.cart;  
        const container = document.createElement('div');
        container.innerHTML = htmlString; 

        const newSubtotal = container.querySelector('[data-cart-total-price]');
         const currentSubtotal = document.querySelector('[data-cart-total-price]');
        
        const newCartForm = container.querySelector('[data-items-wrapper]');
        const currentCartForm = document.querySelector('[data-items-wrapper]');

        if (newCartForm && currentCartForm) {
          currentCartForm.replaceWith(newCartForm);
          currentSubtotal.replaceWith(newSubtotal);
          console.log('Cart updated');
        } else {
          console.warn('Cart not found');
        }
      })
      .catch((error) => {
        console.error('Error updating cart UI:', error);
      });
  }
}

customElements.define('cart-upsells', upsells);
